import { createFileRoute } from "@tanstack/react-router";
import {
    kitsSearchShortLinkRoute,
    ShortLinkRedirect,
} from "@/lib/core/short-links";

export const Route = createFileRoute("/kits-search/$id")({
    beforeLoad: kitsSearchShortLinkRoute.beforeLoad,
    loader: kitsSearchShortLinkRoute.loader,
    component: ShortLinkRedirect,
});
